import axios from 'axios';
import qs from 'qs';
import { API_URL } from '../constants';

const configureAxios = () =>
  axios.create({
    baseURL: API_URL,
    withCredentials: true,
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken',
    paramsSerializer: (params) =>
      qs.stringify(params, { encode: false, arrayFormat: 'comma' }),
  });

export default configureAxios;

export const configureAxiosMock = () =>
  axios.create({
    baseURL: '/api/',
    withCredentials: true,
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken',
    paramsSerializer: (params) =>
      qs.stringify(params, { encode: false, arrayFormat: 'comma' }),
  });
